import { LoadableRoute } from 'routes/utils/loadable';

export const JobsContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "Jobs" */ './Jobs'),
});
